let _navigate = null;

export const setNavigate = fn => {
  _navigate = fn;
};

export const navigate = (path, options) => {
  if (_navigate) {
    _navigate(path, options);
  }
};
